import React, { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
//import { useFormState } from 'react-final-form';

import api from 'lib/api';

import { Icon, translate, Button } from '@haldor/ui';

import Modal from 'containers/Modals/Modal';
import AIConversation from './AIConversation';


class AIPrompt extends Component {

	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			//form: useFormState().values,
		}

		if (this.props.openPicker != null) {
			this.props.openPicker(this.toggleModal);
		}
	}

	toggleModal = () => {
		this.setState({ modal: !this.state.modal });
	}

	onDataFromConversation = (data) => {
		this.props.onDataSend(data);
		this.toggleModal();
	}

	onFormSubmit = (values) => {
	}

	render() {
		return <div>
			<Modal isOpen={this.state.modal} onClose={this.toggleModal} title={this.props.translate('AI Assistance')}>
				<AIConversation text={this.props.text} onDataSend={this.onDataFromConversation} selectedCoreContent={this.props.selectedCoreContent} sections={this.props.sections} />
			</Modal>
			<div style={{ marginTop: '.75rem' }} />

			<Button onClick={(e) => { e.preventDefault(); this.setState({ modal: true }); }}>
				{this.props.translate('Use AI Assistance')}
			</Button>
		</div>
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	}
}

export default connect(mapStateToProps)(AIPrompt);
